// extracted by mini-css-extract-plugin
export default {"gridRow":"grid_gridRow__J2KOK"};